import { useAuth } from "./AuthContext";

export const usePermissions = () => {
  const { hasPermission, hasView, isSuperAdmin } = useAuth();

  const can = (
    module: string,
    action: "read" | "write" | "update" | "delete"
  ) => {
    return isSuperAdmin() || hasPermission(module, action);
  };

  const canView = (module: string, view: string) => {
    return isSuperAdmin() || hasView(module, view);
  };

  const canRead = (module: string) => can(module, "read");
  const canWrite = (module: string) => can(module, "write");
  const canUpdate = (module: string) => can(module, "update");
  const canDelete = (module: string) => can(module, "delete");

  return {
    can,
    canView,
    canRead,
    canWrite,
    canUpdate,
    canDelete,
    isSuperAdmin
  };
};
